import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../../../elements/Box';
import Text from '../../../../elements/Text';

import Icon from '../../../../elements/Icon';

const OverlayLayer = (props) => {
  const {
    showRightIcon = false,
    showLeftIcon = false,
    showDescription = false,
    showTitle = false,
    labelKey = 'cmp-loading-fares',
    titleKey = 'cmp-loading-title-description',
    messageKey = 'cmp-loading-message-description',
    isLoading = true,
    iconSettings = { icon: 'spinner', fontSize: '8', display: 'inline-block' },
    titleSettings = {},
    titleContainerSettings = {},
    textContainerSettings = {},
    textSettings = {},
    enableAccessibilityMessage = false
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <div
      className={`${className} overlay-layer`}
      style={style}
      role={enableAccessibilityMessage ? null : isLoading ? 'alert' : null}
      data-testid="loading"
      aria-label={isLoading ? translate(labelKey, 'Blocked content') : null}
    >
      <Box {...titleContainerSettings}>
        {showTitle && <Text {...titleSettings}>{translate(titleKey, 'Great deals await!')}</Text>}
      </Box>
      <Box {...textContainerSettings} className="icon-layer-container">
        {showRightIcon && <Icon {...iconSettings} />}
        {showDescription && (
          <Text {...textSettings} aria-hidden={enableAccessibilityMessage ? true : false}>
            {translate(messageKey, 'Start by choosing your trip details')}
          </Text>
        )}
        {showLeftIcon && <Icon {...iconSettings} />}
      </Box>
    </div>
  );
};

OverlayLayer.propTypes = {
  /**
   * Show component icon
   */
  showIcon: PropTypes.bool,
  /**
   * label key props
   */
  labelKey: PropTypes.string,
  /**
   * It determines if the alert is
   * going to be assertive so that
   * for accessibility the SR reads
   * it, this prop is added because
   * in the map this alert is used
   * as a decorative element
   */
  isLoading: PropTypes.bool
};

OverlayLayer.componentName = 'OverlayLayer';

export default OverlayLayer;
